<template>
  <div class="panelNagusia">
    <div class="ui breadcrumb">
      <a class="section" v-on:click="goTo('/dashboard')">Home</a>
      <i class="right angle icon divider"></i>
      <a class="active section" v-on:click="goTo('/inventory')">Inventario y Actuaciones</a>
    </div>
    <h1 class="ui header">
      <i class="search icon"></i>
      <div class="content">Inventario y Actuaciones</div>
    </h1>
    <div class="ui stackable one column divided grid container">
      <div class="row">
        <div class="column">
          <table class="ui very basic stackable table">
            <thead>
              <tr>
                <th colspan="2" class="azpian">Lista de opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <h4 class="ui image header">
                    <div class="content">
                      <div class="header">
                        <i class="dolly icon"></i>
                        Stock
                      </div>
                    </div>
                  </h4>
                </td>
                <td class="right aligned">
                  <div class="ui basic button button-size" v-on:click="goTo('/inventory/column/reservation/list')">
                    Reservas</div>
                  <div class="ui basic button button-size" v-on:click="goTo('/inventory/stock/add')">Nuevo</div>
                  <div class="ui basic button button-size" v-on:click="goTo('/inventory/stock/list')">Búsqueda</div>
                </td>
              </tr>

              <tr>
                <td>
                  <h4 class="ui image header">
                    <div class="content">
                      <div class="header">
                        <i class="icon boxes"></i>
                        Recepción de stock
                      </div>
                    </div>
                  </h4>
                </td>
                <td class="right aligned">
                  <div class="ui basic button button-size" v-on:click="goTo('/inventory/stock/receive')">Sin Pedido
                  </div>
                </td>
              </tr>

              <tr>
                <td>
                  <h4 class="ui image header">
                    <div class="content">
                      <div class="header">
                        <i class="icon file alternate outline"></i>
                        Actuaciones
                      </div>
                    </div>
                  </h4>
                </td>
                <td class="right aligned">
                  <div class="ui basic button button-size" v-on:click="goTo('/inventory/action/add')">Nueva</div>
                  <div class="ui basic button button-size" v-on:click="goTo('/inventory/action/list')">Búsqueda</div>
                </td>
              </tr>

              <tr>
                <td>
                  <h4 class="ui image header">
                    <div class="content">
                      <div class="header">
                        <i class="icon history"></i>
                        Historial de columnas
                      </div>
                    </div>
                  </h4>
                </td>
                <td class="right aligned">
                  <div class="ui basic button button-size" v-on:click="goTo('/inventory/column/list')">Búsqueda</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'inventory',

  created() {
    let role = JSON.parse(localStorage.admin).role
    if (role != 'master' && role != 'admin') {
      this.$router.replace('/parcels_v2')
    }
  },

  methods: {
    goTo(where) {
      this.$router.push(where)
    },
  }
}

</script>
<style scoped>
.button-size {
  width: 150px
}
</style>



// WEBPACK FOOTER //
// src/components/Inventory/inventory.vue